/**
 * DevExtreme (ui/context_menu.js)
 * Version: 17.2.18
 * Build date: Fri Dec 03 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./context_menu/ui.context_menu");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/devextreme/ui/context_menu.js
// module id = ../../../../devextreme/ui/context_menu.js
// module chunks = common